import { render, staticRenderFns } from "./InstallmentAdd.vue?vue&type=template&id=252c0ee2&"
import script from "./InstallmentAdd.vue?vue&type=script&lang=js&"
export * from "./InstallmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports